import { useEffect, useState } from "react";
import NavbarComp from "../../shared/components/Navbar";
import Topbar from "../../shared/components/Topbar";
import { Container } from "react-bootstrap";
import ProfileSection from "./components/ProfileSection";
import { useAuth } from "../auth/hooks/useAuth";
import { useProfile } from "./hooks/useProfile";

const ProfilePage = () => {

    const { validate, auth } = useAuth();
    const { addProfile, editProfile, error, loading, profile } = useProfile();

    const [user, setUser] = useState()

    useEffect(() => {
        // (async () => {
        //     const userData = await validate();
        //     setUser(userData);
        // })();
        // validate();
    }, [validate]);

    return (
        <>
            <Container fluid style={{
                backgroundColor: '#f0f0f0',// Make sure the path is correct
                backgroundPosition: 'top right', // Position the image at the top-right corner
                backgroundSize: 'auto', // Adjust the size of the background image
                height: '95vh', // Make the container take full height (optional)    
                overflowY: 'auto',
                overflowX: 'hidden',
            }}>

                <Container className='md justify-content-center'>

                    <NavbarComp />

                    <span style={{
                        fontSize: 12,
                        color: 'gray'
                    }}>RS YARSI</span>

                    <p className='h6' style={{
                        fontSize: 17,
                        display: "flex",
                        alignItems: "center",
                        gap: "2px",
                        padding: '0.1rem',
                        paddingBottom: '2rem'
                    }}>
                        <span>Profil</span>
                    </p>

                    <ProfileSection
                        profile={profile}
                        addProfile={addProfile}
                        editProfile={editProfile}
                        // data={profile}
                        response={{ error: error, loading: loading }}
                    />

                </Container>

            </Container>
        </>
    )
}

export default ProfilePage;